import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Award } from "lucide-react";
import { ScoreGauge } from "./ScoreGauge";
import { IndicatorItem } from "./IndicatorItem";
import { getStatus } from "./analyticsUtils";

export function EfficiencyScoreCard({ efficiency }) {
  const ef = efficiency || {};
  return (
    <Card className="bg-white shadow-sm" data-testid="efficiency-score-card">
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center gap-2 text-gray-800">
          <Award className="w-5 h-5 text-amber-500" />
          Pontuação de Eficiência
        </CardTitle>
      </CardHeader>
      <CardContent>
        <ScoreGauge score={ef.score} grade={ef.grade} />
        {ef.breakdown && (
          <div className="space-y-2 mt-6">
            <IndicatorItem label="Tempo de Preparo"  score={ef.breakdown.prep_time?.score  || 0} value={ef.breakdown.prep_time?.value  || "-"} status={getStatus(ef.breakdown.prep_time?.score)}  />
            <IndicatorItem label="Cancelamentos"     score={ef.breakdown.cancel_rate?.score || 0} value={ef.breakdown.cancel_rate?.value || "-"} status={getStatus(ef.breakdown.cancel_rate?.score)} />
            <IndicatorItem label="Tempo na Fila"     score={ef.breakdown.queue_time?.score  || 0} value={ef.breakdown.queue_time?.value  || "-"} status={getStatus(ef.breakdown.queue_time?.score)}  />
            <IndicatorItem label="Volume"            score={ef.breakdown.volume?.score      || 0} value={ef.breakdown.volume?.value      || "-"} status={getStatus(ef.breakdown.volume?.score)}      />
            <IndicatorItem label="Pedidos no Prazo"  score={ef.breakdown.on_time?.score     || 0} value={ef.breakdown.on_time?.value     || "-"} status={getStatus(ef.breakdown.on_time?.score)}     />
          </div>
        )}
      </CardContent>
    </Card>
  );
}
